import details from './details'

export default {
  title: 'The Nextdev Summit 2020',
  slug: 'tnd-summit-2020',
  createdAt: '1610447748356',
  description:
    'This year, In Collaboration with JakTent, we are presenting to you The Nextdev Summit. An amazing virtual event to connect & facilitate collaboration to accelerate Indonesia’s digital economy.',
  details,
  tint: '#12085c'
}
